module.exports = "/_next/static/images/sprite.icons-e15a8dc0072b92907008623839a53194.svg";